/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React from 'react';
import Modal from "Main/components/layouts/modals/Modal";
import styled, { css } from 'styled-components';

export const ConfirmCancelModal = ({ closeModal, handleConfirm }) => (
  <Modal closeModal={closeModal} showCross showTimes>
    <ContentWrapper>
      <Title>Остановить подписку?</Title>

      <Message>
        Вы уверены, что хотите остановить подписку?
        <br />
        Доступ к материалам сохранится до конца оплаченного периода.
      </Message>

      <ButtonGroup>
        <SecondaryButton type="button" onClick={closeModal}>
          Оставить включенной
        </SecondaryButton>
        <PrimaryButton cancel type="button" onClick={handleConfirm}>
          Остановить
        </PrimaryButton>
      </ButtonGroup>
    </ContentWrapper>
  </Modal>
);

export const ConfirmResumeModal = ({ closeModal, handleConfirm }) => (
  <Modal closeModal={closeModal} showCross showTimes>
    <ContentWrapper>
      <Title>Возобновить подписку?</Title>

      <Message>
        При возобновлении подписки автоматическое списание денежных средств произойдет в последний день оплаченного периода.
      </Message>

      <ButtonGroup>
        <PrimaryButton type="button" onClick={handleConfirm}>
          возобновить
        </PrimaryButton>
      </ButtonGroup>
    </ContentWrapper>
  </Modal>
);

const ContentWrapper = styled.div`
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  max-width: 450px;
  text-align: center;
`;

const Title = styled.h2`
  margin-top: 0;
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 20px;
`;

const Message = styled.p`
  color: #555;
  line-height: 1.5;
  margin-bottom: 25px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
`;

const PrimaryButton = styled.button`
  background: #3190ed;
  ${props => props.cancel && css`background-color: #b22222;`}
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
  min-width: 160px;

  &:hover {
    background: #3182ce;
    ${props => props.cancel && css`background-color: #8b1a1a;`}
  }
`;

const SecondaryButton = styled.button`
  background-color: #f0f0f0;
  color: #333;
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
  min-width: 160px;

  &:hover {
    background-color: #e0e0e0;
  }
`;
